import React from "react";
import { useLocation } from "react-router-dom";
import ModuleSubtopic from "../../../ModuleSubtopic";

const PigeonholePrinciple = () => {
  const location = useLocation();
  const { subtopics, subjectPath } = location.state || { subtopics: [], subjectPath: '' };

  return (
  <ModuleSubtopic
      subtopics={subtopics}
      subjectPath={subjectPath}
      title="Pigeonhole Principle"
    videos={[
      "https://www.youtube.com/embed/uP_b9wCq5LQ?list=PLXj4XH7LcRfBB-4hXp4XI84HOCWkaBD63"
    ]}
    takeaways={[
        {text:"If group codes are in the syllabus,check in the module 2"}
    ]}
    questions={[]}
    exampleVideos={[]}
  />
);
}

export default PigeonholePrinciple;
